/**
 * created by lei lei on 2020/6/20
 * 我的媒体组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Card,Popconfirm,Button} from 'antd';
import  weChat from './img/wechat.png'
import  microBlog from './img/microBlog.png'
import  tiktok from './img/tiktok.png'
import  notFiled from './img/notFiled.png'
import  media from './img/media.jpg'

const customIcon=[{    //新增新图标放到img ，然后引入，自己加入枚举值。
    type:'notFiled',
    icon:notFiled
},{
    type:'weChat',
    icon:weChat
},{
    type:'microBlog',
    icon:microBlog
},{
    type:'tiktok',
    icon:tiktok
},{
    type:'media',
    icon:media
}];
const { Meta } = Card;
export default class MyMediaInformation extends Component {
    static defaultProps = {};
    static propTypes = {
        title:PropTypes.string.isRequired,//媒体标题，
        deleteCallback:PropTypes.func.isRequired,//点击删除按钮后的操作
        authenticationMark:PropTypes.string.isRequired,//文字为是否已认证
        authenticationCallback:PropTypes.func.isRequired,//是否已认证点击
        iconType:PropTypes.string.isRequired,//图表类型
        iconClickCallback:PropTypes.func,//点击图标可实现编辑

    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let icon=weChat
        customIcon.forEach((item,i)=>{
            if(this.props.iconType===item.type){
                icon=item.icon
            }
        })
        return (
            <div >
                <Card
                    hoverable
                    style={{ width: 200 ,padding:10}}
                    cover={<img onClick={()=>{
                        this.props.iconClickCallback&&this.props.iconClickCallback()
                    }}  style={{width:60,height:60,marginLeft:59}} src={icon} />}
                >
                    <Meta title={
                        <div style={{width:130}}>{this.props.title}</div>
                    } style={{textAlign:'center',}} description={
                        <div style={{display:'flex'}}>
                            <div style={{width:100,}} onClick={()=>{this.props.authenticationCallback&&this.props.authenticationCallback()}}>{this.props.authenticationMark}</div>
                            {this.props.record?null:<Popconfirm
                                title="是否删除该账号?"
                                onConfirm={()=>{this.props.deleteCallback&&this.props.deleteCallback()}}
                                onCancel={()=>{}}
                                okText="确认"
                                cancelText="取消"
                            ><div style={{width:100,}}>删除</div></Popconfirm>}

                            {
                                this.props.authentication?null:<Button type="primary" size='small' onClick={()=>{this.props.authenticationCallback&&this.props.authenticationCallback()}} style={{position:'absolute',bottom:0,right:0}}>去认证</Button>
                            }
                        </div>
                    } />
                </Card>
            </div>
        )
    }

}